import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Person } from '@mui/icons-material';

type BorderSize = 'default' | 'wide';

const BORDER_SIZE: Record<BorderSize, number> = {
    default: 1,
    wide: 3,
};

interface AvatarProps {
    imageUrl?: string | null;
    initials?: string;
    size?: number;
    color?: string;
    borderSize?: BorderSize;
    onClick?: () => void;
    id?: string;
    className?: string;
    name?: string;
}

export function Avatar({
    imageUrl,
    initials,
    size = 44,
    color,
    borderSize = 'default',
    onClick,
    id,
    className,
    name,
}: AvatarProps) {
    const fontSize = Math.round(size * 0.32);
    const hasImage = !!imageUrl;
    const initialsDisplay =
        initials ||
        name
            ?.split(' ')
            .map((part) => part[0] ?? '')
            .join('')
            .slice(0, 2);

    return (
        <Container
            id={id}
            onClick={onClick}
            style={{
                width: size,
                height: size,
                fontSize,
                backgroundColor: hasImage ? undefined : color ?? Colors.fill,
                color: color ? Colors.white : Colors.primary,
                border: hasImage ? `${BORDER_SIZE[borderSize]}px solid ${color ?? Colors.border}` : undefined,
                cursor: onClick ? 'pointer' : 'default',
            }}
            className={className}
        >
            {hasImage ? (
                <Image src={imageUrl} alt={initialsDisplay || 'avatar'} />
            ) : initialsDisplay ? (
                initialsDisplay
            ) : (
                <Person htmlColor={Colors.textSecondary} sx={{ fontSize: Math.round(size * 0.7) }} />
            )}
        </Container>
    );
}

const Container = styled('div')({
    borderRadius: '50%',
    backgroundColor: Colors.fill,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    color: Colors.primary,
    position: 'relative',
    overflow: 'visible',
    flexShrink: 0,
});

const Image = styled('img')({
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
});
